<template>
    <div class="radio-box">
        <img :src="selected?require('@/assets/images/duihao-choose.jpg'):require('@/assets/images/choose-icon.jpg')" style="width:31px;height:31px;"/>
        <input value="2" class="input-radio" type="radio">支付
    </div>
</template>

<script>
    export default {
        name: "Radio",
        props: {
            label: String,
            imgWidth: {
                default:"30px",
            },
            imagePath:{
                default:"",
            },
            selected: {
                default: false,
            }
        },
        data: function () {
            return {
                labelValue: '66',
                radio: 0
            };
        }
    }
</script>

<style lang="scss" scoped>
.radio-box{
  display: inline-block;
  position: relative;
  height: 25px;
  line-height: 25px;
  margin-right: 5px;
}
.radio {
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  cursor: pointer;
  background-image: url(../../assets/images/duihao-choose.jpg);
  background-repeat: no-repeat;
  background-position: 0 0;
}
.input-radio {
  display: inline-block;
  position: absolute;
  opacity: 0;
  width: 25px;
  height: 25px;
  cursor: pointer;
  left: 0px;
  outline: none;
  -webkit-appearance: none;
}
.on {
  background-position: -25px 0;
}
</style>